import HomeFeature from "@/features/Home";

export default function HomePage() {
  return (
    <main className=" md:w-[80vw] lg:w-[70vw] mx-auto pb-25 ">
      <HomeFeature />
    </main>
  );
}
